// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a941d4e7","703":"6456485d"}[chunkId] + ".chunk.js";
};